/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectAutopsiesComponent} from './select-autopsies/select-autopsies.component';
import {SelectRemovalPointsComponent} from './select-removal-points/select-removal-points.component';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {SelectPaymentComponent} from './select-payment/select-payment.component';
import {ServicesModule} from '../../_services/services.module';
import {SelectAnimalSpeciesComponent} from './select-animal-species/select-animal-species.component';
import {SelectAnimalCategoriesComponent} from './select-animal-categories/select-animal-categories.component';
import {SelectAnimalGendersComponent} from './select-animal-genders/select-animal-genders.component';
import {SelectAnimalTypesComponent} from './select-animal-types/select-animal-types.component';
import {SelectCountriesComponent} from './select-countries/select-countries.component';
import {SelectThirdPartiesComponent} from './select-third-parties/select-third-parties.component';

@NgModule({
  declarations: [
    SelectAnimalCategoriesComponent,
    SelectAnimalGendersComponent,
    SelectAnimalSpeciesComponent,
    SelectAnimalTypesComponent,
    SelectCountriesComponent,
    SelectAutopsiesComponent,
    SelectPaymentComponent,
    SelectRemovalPointsComponent,
    SelectThirdPartiesComponent
  ],

  exports: [
    SelectAnimalCategoriesComponent,
    SelectAnimalGendersComponent,
    SelectAnimalSpeciesComponent,
    SelectAnimalTypesComponent,
    SelectCountriesComponent,
    SelectAutopsiesComponent,
    SelectPaymentComponent,
    SelectRemovalPointsComponent,
    SelectThirdPartiesComponent
  ],
  imports: [
    CDKModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    ServicesModule
  ]
})

export class SelectsModule {
}
